<template>
  <ModalDialog
    ref="dialog"
    title="Order Editor Settings"
    submitTitle="Update"
    icon="fa-cog"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="6" v-if="loadedSettings">
      <div class="row">
        <div class="col-6">
          <ContentTitle>Display</ContentTitle>
          <FormRow label="Theme">
            <FormOption label="Light" name="themeId" setting="light" v-model="editorSettings.themeId" />
            <FormOption label="Dark" name="themeId" setting="dark" v-model="editorSettings.themeId" />
          </FormRow>
          <FormRow label="Display Grid">
            <FormSwitch booleanMode v-model="editorSettings.appGridEnabled" />
          </FormRow>
          <FormRow label="Display Rulers">
            <FormSwitch booleanMode v-model="editorSettings.appRulersEnabled" />
          </FormRow>

          <div class="mt-4">
            <ContentTitle>Misc</ContentTitle>
            <FormButton @click="reloadConfig" :loading="reloadingConfig" class="btn-default" loadingColour="#808080">Reload Editor Config Data</FormButton>
          </div>
        </div>
        <div class="col-6">
          <ContentTitle>Measurements</ContentTitle>
          <FormRow label="Units">
            <FormStaticLabel>Millimetres</FormStaticLabel>
          </FormRow>
          <FormRow label="Linear Dimension Precision">
            <FormSelect :options="precisionOptions" v-model="editorSettings.linearDimensionPrecision" />
          </FormRow>
          <FormRow label="Angular Dimension Precision">
            <FormSelect :options="precisionOptions" v-model="editorSettings.angularDimensionPrecision" />
          </FormRow>
          <FormRow label="Display Linear Dimension Units">
            <FormSwitch booleanMode v-model="editorSettings.displayLinearDimensionUnits" />
          </FormRow>
          <FormRow label="Display Angular Dimension Units">
            <FormSwitch booleanMode v-model="editorSettings.displayAngularDimensionUnits" />
          </FormRow>
          <FormRow label="Dimension Trailing Zeroes">
            <FormSwitch booleanMode v-model="editorSettings.displayDimensionTrailingZeros" />
          </FormRow>          
        </div>
      </div>
      
    </FormGroup>

  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'EditorSettingsDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    editor: Object
  },
  data() {
    return {
      dialogForm: {},
      loadedSettings: false,
      editorSettings: {},
      precisionOptions: [
        { value: 0, name: 'None' },
        { value: 1, name: '0.1' },
        { value: 2, name: '0.12' },
        { value: 3, name: '0.123' },
      ],
      reloadingConfig: false
    }
  },
  mounted() {
    
  },
  computed: {
    
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.dialogForm = { }
      this.editorSettings = _.cloneDeep(options)
      this.loadedSettings = true

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.dialogForm = this.clearFormResponse()

      let updateData = _.cloneDeep(this.editorSettings)
      updateData.linearDimensionPrecision = parseInt(updateData.linearDimensionPrecision)
      updateData.angularDimensionPrecision = parseInt(updateData.angularDimensionPrecision)

      this.modalClosed(updateData)
      this.hide()
    },
    reloadConfig() {
      this.reloadingConfig = true
      this.editor.loadConfigurationData()
      .then(() => {
      })
      .catch(err => {
        this.displayNetworkError(err, 'Error Reloading Config')
      })
      .finally(() => {
        this.reloadingConfig = false
      })
    }
    
  }
}
</script>